const createInput = ({ type = 'hidden', name, value }) => {
    const input = document.createElement('input');

    input.name = name;
    input.type = type;
    input.value = value;

    return input;
};

export const createForm = ({ container, method = 'post', action, inputs, target, postContentType }) => {
    const form = document.createElement('form');

    form.action = action;
    form.method = method;
    form.target = target;
    form.enctype = postContentType;

    Object.keys(inputs).forEach(function (name) {
        form.appendChild(createInput({ name, value: inputs[name] }));
    });

    if (!container) {
        container = document.body;
    }

    container.appendChild(form);

    return form;
};
